import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "./i18n";
import { useLenis } from "./hooks/useLenis";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { MineralsCarousel } from "./components/MineralsCarousel";
import { About } from "./components/About";
import { Process } from "./components/Process";
import { DueDiligence } from "./components/DueDiligence";
import { GlobalMarkets } from "./components/GlobalMarkets";
import { MarketPrices } from "./components/MarketPrices";
import { Services } from "./components/Services";
import { RequestTransaction } from "./components/RequestTransaction";
import { Contact } from "./components/Contact";
import { PortsCTA } from "./components/PortsCTA";
import { PortsOverlay } from "./components/PortsOverlay";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import { Cursor } from "./components/Cursor";
import { Particles } from "./components/Particles";
import { Subliminal } from "./components/Subliminal";
import { AudioPlayer } from "./components/AudioPlayer";
import { BackToTop } from "./components/BackToTop";

function Site() {
  useLenis();
  return (
    <div className="min-h-screen bg-[#07111F] font-body text-[#F5F7FA] antialiased overflow-x-clip">
      <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
        <div className="aurora-blob aurora-gold" />
        <div className="aurora-blob aurora-silver" />
      </div>
      <Particles />
      <Subliminal />
      <Cursor />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <MineralsCarousel />
        <About />
        <Process />
        <DueDiligence />
        <GlobalMarkets />
        <MarketPrices />
        <Services />
        <RequestTransaction />
        <Contact />
        <PortsCTA />
      </main>
      <Footer />
      <PortsOverlay />
      <WhatsAppFloat />
      <BackToTop />
      <AudioPlayer />
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Site />
    </LanguageProvider>
  );
}

export default App;
